import React, { memo } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { AccountTypeChip } from "fond/widgets/AccountSwitch";

interface TypeCellRendererProps extends ICellRendererParams {
  value: "Admin" | "Member" | "Guest" | "External";
}

const TypeCellRenderer: React.FC<TypeCellRendererProps> = memo(({ value }: TypeCellRendererProps) => {
  return <AccountTypeChip external={value === "External"} role={value.toLowerCase()} />;
});

TypeCellRenderer.displayName = "TypeCellRenderer";

export default TypeCellRenderer;
